import { Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from '../../contexts/translation';
import { OpcClientInputs } from '../../types/app/opcClient.types';
import { dictionary } from '../../utils/core/dictionary';
interface Props {
  onSubmit: SubmitHandler<OpcClientInputs>;
  defaultValues?: OpcClientInputs;
  onBack: any;
}

export function OpcClientForm({ onSubmit, defaultValues, onBack }: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<OpcClientInputs>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={t('page.opc-client.edit-input-label-1')}
              {...register('instanceName', {
                required: t('page.opc-client.validation-required-instance-name'),
              })}
              error={Boolean(errors.instanceName)}
              helperText={errors.instanceName?.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={dictionary.ENDPOINT_ADDRESS}
              {...register('endpointAddress', {
                required: dictionary.ENDPOINT_ADDRESS + dictionary.IS_REQUIRED,
              })}
              error={Boolean(errors.endpointAddress)}
              helperText={errors.endpointAddress?.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t('page.opc-client.edit-input-label-2')}
              {...register('comment')}
              error={Boolean(errors.comment)}
              helperText={errors.comment?.message}
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
